var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user != null
    ? _c("div", [
        _c(
          "ul",
          { staticClass: "pushed-menu d-lg-block d-none" },
          _vm._l(_vm.currentPushedApps, function(menu, index) {
            return _c(
              "li",
              {
                key: index,
                class: [
                  "nav-item",
                  menu.isActive() ? "active" : "",
                  menu.hasSubMenu() ? "has-sub-menu" : ""
                ]
              },
              [
                _c(
                  "a",
                  { attrs: { href: menu.href } },
                  [
                    menu.icon
                      ? _c("icon", { attrs: { name: menu.icon } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(menu.label))
                    ]),
                    menu.badge > 0
                      ? _c(
                          "b-badge",
                          {
                            staticClass: "ml-1  align-middle",
                            attrs: { pill: "", variant: "danger" }
                          },
                          [_vm._v(_vm._s(menu.badge))]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                menu.hasSubMenu()
                  ? _c(
                      "ul",
                      { staticClass: "sub-menu" },
                      _vm._l(menu.subMenu, function(sub, subIndex) {
                        return _c("li", { key: index + subIndex }, [
                          _c(
                            "a",
                            { attrs: { href: sub.href } },
                            [
                              sub.icon
                                ? _c("icon", { attrs: { name: sub.icon } })
                                : _vm._e(),
                              _vm._v(_vm._s(sub.label))
                            ],
                            1
                          )
                        ])
                      })
                    )
                  : _vm._e()
              ]
            )
          })
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-lg-none d-block" },
          [
            _c(
              "b-navbar",
              { attrs: { toggleable: "lg", type: "dark" } },
              [
                _c("b-navbar-brand", { attrs: { href: "#" } }, [
                  _c(
                    "a",
                    { attrs: { href: "#" } },
                    [
                      _vm.user
                        ? _c("LetterAvatar", {
                            staticClass: "profile-picture",
                            attrs: { initials: _vm.user.initials() }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.user && _vm.user.role
                        ? _c("span", { staticClass: "username" }, [
                            _vm._v(
                              _vm._s(_vm.user.lastname) +
                                " " +
                                _vm._s(_vm.user.firstname)
                            ),
                            _c("br"),
                            _vm._v(
                              "\r\n          (" +
                                _vm._s(_vm.user.role.libelle) +
                                ")"
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("b-navbar-toggle", { attrs: { target: "nav-collapse" } }),
                _vm._v(" "),
                _c(
                  "b-collapse",
                  { attrs: { id: "nav-collapse", "is-nav": "" } },
                  [
                    _c(
                      "b-navbar-nav",
                      [
                        _vm._l(_vm.currentPushedApps, function(menu, index) {
                          return _c(
                            "b-nav-item",
                            {
                              key: index,
                              class: [
                                "nav-item",
                                menu.isActive() ? "active" : "",
                                menu.hasSubMenu() ? "has-sub-menu" : ""
                              ],
                              attrs: { href: menu.href }
                            },
                            [
                              menu.icon
                                ? _c("icon", { attrs: { name: menu.icon } })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "align-middle" }, [
                                _vm._v(_vm._s(menu.label))
                              ]),
                              menu.badge > 0
                                ? _c(
                                    "b-badge",
                                    {
                                      staticClass: "ml-1  align-middle",
                                      attrs: { pill: "", variant: "danger" }
                                    },
                                    [_vm._v(_vm._s(menu.badge))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c("b-nav-item", [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.logout($event)
                                }
                              }
                            },
                            [
                              _c("icon", {
                                attrs: { name: "power_settings_new" }
                              }),
                              _vm._v("Logout")
                            ],
                            1
                          )
                        ])
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-210a7296", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-210a7296","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/PushedMenu.vue
// module id = s3eL
// module chunks = 15